import { useState } from "react"

export const useListToggler = () => {
    const [list, setList] = useState<string[]>([]);
    return {
        list: list,
        isInList: (e: string) => list?.indexOf(e) >= 0,
        toggleListIem: (e: string) => {
            if (list?.indexOf(e) >= 0) {
                setList([...(list?.filter(k => k != e))])
            } else {
                setList([...list, e])
            }
        }
    }
}